export default __webpack_public_path__ + "static/media/ellipses.4b00a96d.svg";